module.exports = __webpack_public_path__ + "img/get-a-review.26ced5ba.jpg";